import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable, of } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { AppState } from '../../../app.service';
import { AppVars } from '../../../app.vars';

export interface AutomationConfig {
  useSeenLabel?: boolean;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class AutomationConfigService {
  constructor(private db: AngularFireDatabase, private appState: AppState) {}

  public getAppointmentFlowConfig(): Observable<AutomationConfig> {
    const orgCode = this.appState.get(AppVars.ORG_CODE);
    if (!orgCode) {
      return of({});
    }
    const path = `provider-org-${orgCode}/automation/appointment-flow`;
    return this.db.object<AutomationConfig>(path).valueChanges().pipe(
      map(config => config || {}),
      tap(config => {
        this.appState.set(AppVars.AUTOMATION_CONFIG, config);
      }),
      shareReplay(1)
    );
  }
}
